export enum DataType {
  Boolean = 'boolean',
  Number = 'number',
  Object = 'object',
  String = 'string',
}
